export default __webpack_public_path__ + "static/media/booking-bg.646bc84c.png";